(function () {
    "use strict";

    angular.module("cardFrontConsumer")
        .config(config);

    config.$inject = ["$routeProvider", "NAV_URLS"];

    function config($routeProvider, NAV_URLS) {

        $routeProvider
            .when(NAV_URLS.CARDHOLDER_AGREEMENT, {
                templateUrl: "areas/cardholder-agreement/cardholder-agreement.html",
                controller: "CardholderAgreement",
                controllerAs: "model",
                titleTranslationId: "CARDHOLDER_AGREEMENT.TITLE",
                resolve: {
                    site: resolveSite
                }
            });

        resolveSite.$inject = ["siteService"];

        function resolveSite(siteService) {
            return siteService.get();
        }
    }
}());